export const ZOHO_ACTIVATION_STATUS_QUERY = 'zohoActivationStatus';
